import { type IAnalyticEventsConfig } from "@magnit/analytic-events/src/manager";

export const productDetailsEvents: IAnalyticEventsConfig = {
  "CardDetail:Share:View": {
    ya: {
      eventName: "catProduct_share_view",
      page: "catProduct",
      block: "share",
    },
  },
  "CardDetail:Share:Icon:Click": {
    ya: {
      eventName: "catProduct_share_icon_click",
      page: "catProduct",
      block: "share",
      element: "icon",
    },
  },
  "CardDetail:Share:Close": {
    ya: {
      eventName: "catProduct_share_buttonClose_click",
      page: "catProduct",
      block: "share",
      element: "buttonClose",
    },
  },
  "CardDetail:Share:Link:Click": {
    ya: {
      eventName: "catProduct_share_link_click",
      page: "catProduct",
      block: "share",
      element: "link",
    },
  },
  "CardDetail:View": {
    ya: {
      eventName: "catProduct_view",
      page: "catProduct",
    },
  },
  "CardDetail:Share:Click": {
    ya: {
      eventName: "catProduct_share_click",
      page: "catProduct",
      element: "share",
    },
  },
  "CardDetail:Rating:View": {
    ya: {
      eventName: "catProductReviews_view",
      page: "catProductReviews",
    },
  },
  "CardDetail:Rating:Click": {
    ya: {
      eventName: "catProduct_reviews_click",
      page: "catProductReviews",
      element: "element",
    },
  },
};
